import { makeGetAllCoursesUser } from 'main/factories/usecases/courses/remote-get-all-courses-user-factory';
import { makeGetAllGroupsUser } from 'main/factories/usecases/groups/remote-get-all-groups-user-factory';
import { makeGetAllOrganizationsUser } from 'main/factories/usecases/organizations/remote-get-all-organizations-user-factory';
import { PushNotification } from 'presentation/app/modules/PushNotification/pages';
import React from 'react';

export const MakePushNotification: React.FC = () => {
  return (
    <PushNotification
      getAllCoursesUser={makeGetAllCoursesUser()}
      getAllOrganizationsUser={makeGetAllOrganizationsUser()}
      getAllGroupsUser={makeGetAllGroupsUser()}
    />
  );
};
